// extracted by mini-css-extract-plugin
export var notificationHost = "_hv-0";